import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import { FunctionComponent } from 'react';
import { OfferingsPlatterWidgetFormFields } from 'components/consumer-page-widgets/offerings-platter-widget/OfferingsPlatterWidgetFormFields';
import { Widgets } from '@tock/shared/types/widget';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';

interface CreateOfferingsPlatterWidgetFormProps {
  onCompleteOrCancel(): void;
}

export const CreateOfferingsPlatterWidgetForm: FunctionComponent<
  React.PropsWithChildren<CreateOfferingsPlatterWidgetFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const handleSubmit = ({ name }: BaseWidgetFormFields) => {
    return createNamedConfig({
      name: name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      offeringsPlatterWidgetConfig: {},
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <OfferingsPlatterWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
